import { api } from "api";
import React from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import { Field, FieldArray, formValueSelector, reduxForm, } from 'redux-form';
import {
    renderTimeField,
    SelectField,
    AsyncSelectField,
    renderNumberPercentage,
    renderTextArea,
    renderDatePicker
} from '../../../Utils/renderField/renderField';
import CardEmpty from "Utils/Cards/CardEmpty";
import { nivel_contaminacion } from "../../../../../utility/constants";
import moment from 'moment';
import { HeaderDRC, PromediosDRC, renderDatosDRC } from "./DatosDRC/DatosDRC";
import { calcularDRCSolidos, getVariacionDRCSolidosFromFinca } from "../../../Utils/LaboratorioDRC/CalculosDRCSolidos";
import { aplicarVariacionDRCSolidos } from "../../../Utils/LaboratorioDRC/Common";

const ver_img = require('assets/img/icons/ver.png');

const getContaminantes = (search) => {
    return api.get("contaminante", { search, no_paginar: true, }).
        then((data) => {
            if (data) {
                return data.results;
            }
            return [];
        }).catch(() => {
            return [];
        });
};

const renderContaminantes = ({ fields, updateData }) => (
    <div className=" col-sm-12 p-0">
        <div className=" col-sm-12 form-group np-r p-0">
            <div className="react-bs-container-header table-header-wrapper">
                <table className="table mb-0">
                    <thead>
                        <tr>
                            <th style={{ width: "20%" }} />
                            <th style={{ width: "10%" }} />
                            <th className="text-center" style={{ width: "20%" }}>CONTAMINANTE</th>
                            <th className="text-center" style={{ width: "20%" }}>NIVEL</th>
                            <th style={{ width: "20%" }} />
                        </tr>
                    </thead>
                </table>
            </div>
            {/*Contenido de la tabla*/}
            <div>
                <table className="table table-sm  m-0 table-striped">
                    <tbody>
                        {fields.map((contaminante, index) => {
                            let todos = fields.getAll();
                            const dato_actual = fields.get(index); // Pago actual
                            todos[index]['index'] = index; //Mutar cada fila par agregarle el index
                            return (
                                <tr key={index}>
                                    <td style={{ width: "20%" }}></td>
                                    <td className="text-center sin-borde-top" style={{ width: "10%" }}>
                                        <img src={require('assets/img/icons/borrar.png')} alt="Borrar"
                                            title="Borrar" className="action_img"
                                            onClick={() => {
                                                fields.remove(index)
                                                // if (dato_actual.hasOwnProperty('id')) {
                                                //     dato_actual.activo = false;
                                                //     updateData(dato_actual, 'contaminantes');
                                                // } else {
                                                // }
                                            }}
                                        />
                                    </td>
                                    <td className="sin-borde-top" style={{ width: "20%" }}>
                                        <Field
                                            valueKey="id"
                                            name={`${contaminante}.material_contaminante`}
                                            labelKey="nombre"
                                            label="nombre"
                                            component={AsyncSelectField}
                                            loadOptions={getContaminantes}
                                        />
                                    </td>
                                    <td style={{ width: "20%" }}>
                                        <Field
                                            name={`${contaminante}.nivel_contaminacion`}
                                            component={SelectField}
                                            options={nivel_contaminacion}
                                            className="form-control"
                                        />
                                    </td>
                                    <td style={{ width: "20%" }}></td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <div className="d-flex justify-content-center mt-2">
                <button type="button" className="btn btn-outline-info py-0" onClick={() => fields.push({})}>
                    AGREGAR CONTAMINANTE
                </button>
            </div>
        </div>
    </div>
);

let LaboratorioSolidoForm = props => {
    const { handleSubmit, item, toogleInfo, ver_info, validar, actualizarYEnviarValidacion } = props;

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-group grid-container">
                <div className="d-flex justify-content-center mb-3">
                    <button className="btn btn-outline-info" onClick={e => {
                        e.preventDefault();
                        toogleInfo()
                    }}>
                        VER DETALLE DE RECEPCIÓN
                        <img src={ver_img} alt="Ver" className="action_img" />
                    </button>
                </div>
                {(item.ingreso && item.ingreso.finca && ver_info) && (
                    <div className="d-flex  justify-content-center mb-4">
                        <div className="col-8">
                            <div className="row col-12">
                                <div className="col-12 d-flex justify-content-between align-items-baseline">
                                    <h6 className="mb-4">DATOS GENERALES DE RECEPCIÓN</h6>
                                </div>
                            </div>
                            <div className="row col-md-12 p-0">
                                <div className="col-md-6 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">FINCA</label>
                                        <span className="mb-1">{item.ingreso.finca.nombre}</span>
                                        <label className="p-0 m-0">VEHÍCULO</label>
                                        <span className="mb-1">{item.ingreso.vehiculo.nombre}</span>
                                        <label className="p-0 m-0">LUGAR</label>
                                        <span className="mb-1">{item.ingreso.acopio ? item.ingreso.acopio.nombre : 'Planta ERSA'}</span>
                                    </div>
                                </div>
                                <div className="col-md-6 p-0">
                                    <div className="col-12 d-flex flex-column">
                                        <label className="p-0 m-0">PILOTO</label>
                                        <span className="mb-1">{item.ingreso.piloto.nombre}</span>
                                        <label className="p-0 m-0">TIPO DE MATERIA</label>
                                        <span className="mb-1">{item.ingreso.tipo_materia.nombre}</span>
                                        <label className="p-0 m-0">FECHA Y HORA DE INGRESO</label>
                                        <span className="mb-1">{moment(item.ingreso.fecha_entrada).format('DD/MM/YYYY hh:mm A')}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {item.ingreso && (
                    <div className="d-flex justify-content-between align-items-end verde-secundario mb-3">
                        <div className="d-flex align-items-end"></div>
                        <div className="d-flex align-items-baseline">
                            <span className="bold mr-2">ID RECEPCIÓN</span>
                            <h4 className="gris bold mr-3">{item.ingreso.display_id || item.ingreso.id}</h4>
                            <span className="bold mr-2">PRODUCTO</span>
                            <h4 className="gris bold">{item.movimiento.materia_prima.nombre}</h4>
                        </div>
                    </div>
                )}
                <div className="row mb-3">
                    <div className="col-12">
                        <CardEmpty noShadow noPadding>
                            <div className="col-12 m-0 py-3 d-flex flex-wrap justify-content-between">
                                <div className="row col-md-12 p-0 d-flex flex-wrap align-items-end">
                                    <div className="col-lg-6 p-0">
                                        <div className="col-12">
                                            <label htmlFor="fecha_analisis" className="m-0">FECHA DE INICIO DE LABORATORIO</label>
                                        </div>
                                        <div className="col-lg-12  form-group">
                                            <Field
                                                name="fecha_analisis"
                                                component={renderDatePicker}
                                                todayButton="Hoy"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 p-0">
                                        <div className="col-12">
                                            <label htmlFor="hora_analisis" className="m-0">HORA DE INICIO DE LABORATORIO</label>
                                        </div>
                                        <div className="col-lg-12  form-group">
                                            <Field
                                                name="hora_analisis"
                                                component={renderTimeField} type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CardEmpty>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12">
                        <CardEmpty noShadow noPadding>
                            <div className="row col-12 m-0 py-3">
                                <div className="row col-12 ml-1">
                                    <h6 className="">DATOS DRC DE LABORATORIO</h6>
                                </div>
                                <div className="col-12">
                                    <HeaderDRC {...props} />
                                    <PromediosDRC {...props} />
                                </div>
                                <FieldArray name="datos_drc" component={renderDatosDRC} {...props} />
                            </div>
                        </CardEmpty>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12">
                        <CardEmpty noShadow>
                            <div className="row col-12 m-0 py-3">
                                <h6 className="">CONTROL DE SUCIEDAD</h6>
                                <FieldArray name="datos_contaminantes" component={renderContaminantes} {...props} />
                            </div>
                        </CardEmpty>
                    </div>
                </div>
                <div className="row col-12 m-0 py-3">
                    <div className="col-12 m-0 p-0">
                        <div className="col-12 ml-1">
                            <h6 className="">OBSERVACIONES</h6>
                        </div>
                        <div className="col-12">
                            <Field name="observaciones" component={renderTextArea} />
                        </div>
                    </div>
                </div>
                <div className="buttons-box mt-5">
                    <Link className="btn btn-outline-dark mr-5" to="/laboratorio/analisis_solido">CANCELAR</Link>
                    <button type="submit" className="btn btn-primary">GUARDAR</button>
                    <button type="button" className="ml-5 btn btn-secondary" disabled={!validar}
                        onClick={handleSubmit(actualizarYEnviarValidacion)}>
                        ENVIAR DRC A VALIDACIÓN
                    </button>
                </div>
            </div>
        </form>
    )
};

LaboratorioSolidoForm = reduxForm({
    form: 'LaboratorioSolidoForm',
    initialValues: {
        multiple_ingreso: false,
        drc: [{}],
        tsc: [{}],
        vfa: [{}],
        nh3: [{}],
        contaminantes: [{}]
    },
})(LaboratorioSolidoForm);

const selector = formValueSelector('LaboratorioSolidoForm');
LaboratorioSolidoForm = connect(state => {
    const form = state.form.LaboratorioSolidoForm;
    const datos_modal = state.laboratorio.drc_temporal;
    const RANGO_DRC = state.configuracion.configuraciones.variable_rango_drc;
    let drc_promedio = 0;
    let validar = false;
    let array_drcs = [];
    let array_drc_promedios = [];
    let drc_minimo, min = 0;
    let drc_maximo, max = 0;
    let drc_diferencia = 0;
    let drc_promedio_1 = 0;
    let drc_promedio_2 = 0;
    let drc_promedio_3 = 0;
    let alerta = false;
    let texto_alerta = '';
    let variacionDRC = {};

    if (form && form.values) {
        const values = form.values;

        // Aplicar la validacion de los DRC
        variacionDRC = getVariacionDRCSolidosFromFinca(values);

        form.values.aplica_variacion_drc = variacionDRC.aplica;
        form.values.variacion_drc = variacionDRC.variacion;

        if (values.datos_drc) {
            values.datos_drc.forEach((dato, index) => {
                if (variacionDRC.aplica) {
                    dato.peso_seco_1 = aplicarVariacionDRCSolidos(dato.peso_seco_1_original, variacionDRC.variacion);
                    dato.peso_seco_2 = aplicarVariacionDRCSolidos(dato.peso_seco_2_original, variacionDRC.variacion);
                    dato.peso_seco_3 = aplicarVariacionDRCSolidos(dato.peso_seco_3_original, variacionDRC.variacion);
                } else {
                    dato.peso_seco_1 = dato.peso_seco_1_original;
                    dato.peso_seco_2 = dato.peso_seco_2_original;
                    dato.peso_seco_3 = dato.peso_seco_3_original;
                }
                // Calcular DRC
                const drc = calcularDRCSolidos(dato);
                dato.drc_promedio_1 = drc.drc_promedio_1;
                dato.drc_promedio_2 = drc.drc_promedio_2;
                dato.drc_promedio_3 = drc.drc_promedio_3;
                dato.drc_promedio_total = (drc.drc_promedio_1 + drc.drc_promedio_2 + drc.drc_promedio_3) / 3;

                // actualizar en form
                form.values.datos_drc[index] = dato;
            });
        }

        // Calculos de los DRC Promedio del modal
        const promediosDRC = calcularDRCSolidos(datos_modal);

        drc_promedio_1 = promediosDRC.drc_promedio_1;
        drc_promedio_2 = promediosDRC.drc_promedio_2;
        drc_promedio_3 = promediosDRC.drc_promedio_3;

        if (drc_promedio_1 && drc_promedio_2 && drc_promedio_3) {
            array_drc_promedios.push(drc_promedio_1);
            array_drc_promedios.push(drc_promedio_2);
            array_drc_promedios.push(drc_promedio_3);
        }

        // Calculo de Promedio DRC Total por todos los DRC
        let count_drc = 0;
        if (values.datos_drc) {

            let sumatoria_drc = 0;
            values.datos_drc.forEach((dato) => {
                if (dato.drc_promedio_total) {
                    if (dato.hasOwnProperty('activo')) {
                        if (dato.activo === true) {
                            array_drcs.push(dato.drc_promedio_total)
                            count_drc += 1;
                            sumatoria_drc += dato.drc_promedio_total
                        }
                    } else {
                        sumatoria_drc += dato.drc_promedio_total;
                        count_drc += 1;
                        array_drcs.push(dato.drc_promedio_total)
                    }
                }
            });
            drc_promedio = sumatoria_drc / count_drc;
            drc_minimo = Math.min(...array_drcs);
            drc_maximo = Math.max(...array_drcs);
            drc_diferencia = drc_maximo - drc_minimo;

            form.values.drc_promedio = drc_promedio;
            form.values.drc_minimo = drc_minimo;
            form.values.drc_maximo = drc_maximo;
            form.values.drc_diferencia = drc_diferencia;
        }

        if (values.drc_promedio) {
            validar = true;
        }

        if (array_drc_promedios.length > 0) {
            min = Math.min(...array_drc_promedios)
            max = Math.max(...array_drc_promedios)

            min = min * 100;
            max = max * 100;

            // console.log("Min", min, " - Max", max);
            // console.log((max-min) > RANGO_DRC);

            if ((max - min) > RANGO_DRC) {
                // console.log("SI ENTRO");
                alerta = true;
                texto_alerta = 'Los valores de DRC se excedieron por mas de 3 puntos';
                // console.log("ALERTA", alerta, texto_alerta);
            }
        }
    }
    return {
        c: 0,
        drc_promedio_1,
        drc_promedio_2,
        drc_promedio_3,
        validar,
        drc_minimo,
        drc_maximo,
        drc_diferencia,
        drc_promedio,
        alerta,
        texto_alerta,
        variacionDRC,
    }
})(LaboratorioSolidoForm);

export default LaboratorioSolidoForm
